import {makeStyles} from '@material-ui/core/styles'
import ServiceSetImportTemplate from '../../../components/5templates/ServiceSetImportTemplate'
import {useNavigate, useParams} from 'react-router-dom'
import {useContext, useState} from 'react'
import FormSuccessSnackbar from '../../../components/2compounds/FormSuccessSnackbar'
import ApproveModal from '../../../components/2compounds/ApproveModal'
import {approveDataImportRecord, rejectDataImportRecord} from '../../../services/util/miscellaneousService'
import {getItemFromSessionStorage} from '../../../services/util/sessionStorageManager'
import RejectModal from '../../../components/2compounds/RejectModal'
import {GlobalContext} from '../../../services/context/DataContext'

const ApproveNewServiceForm = () => {
    const classes = useStyles()
    const navigate = useNavigate()
    const id = useParams().id
    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false)
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false)
    const [isSuccessSnackbarOpen, setIsSuccessSnackbarOpen] = useState(false)
    const {dataManagementNotificationCount: dataManagementNotificationCountContext} = useContext(GlobalContext)
    const [, setDataManagementNotificationCount] = dataManagementNotificationCountContext


    const rejectButtonHandler = () => {
        setIsRejectModalOpen(true)
    }

    const approveButtonHandler = () => {
        setIsApproveModalOpen(true)
    }

    const onApprove = () => {
        approveDataImportRecord(id)
            .then(()=>{
                setIsSuccessSnackbarOpen(true)
                window.setTimeout(()=>{
                    setDataManagementNotificationCount(prevState => prevState - 1)
                    navigate('/adminDashboard')
                }, 2000)
            })
    }

    const onReject = (reason) => {
        const initiatorEmail = getItemFromSessionStorage('initiatorEmail')
        rejectDataImportRecord(id, reason, initiatorEmail)
            .then(()=>{
                setIsSuccessSnackbarOpen(true)
                window.setTimeout(()=>{
                    navigate('/adminDashboard')
                }, 2000)
            })
    }


    return (
        <div className={classes.root}>
            <ServiceSetImportTemplate onReject={rejectButtonHandler} onApprove={approveButtonHandler} disabled />
            <ApproveModal open={isApproveModalOpen} setOpen={setIsApproveModalOpen} approveHandler={onApprove} />
            <RejectModal open={isRejectModalOpen} setOpen={setIsRejectModalOpen} rejectHandler={onReject} />
            <FormSuccessSnackbar isSnackbarOpen={isSuccessSnackbarOpen} setIsSnackbarOpen={setIsSuccessSnackbarOpen} />
        </div>
    )
}

export default ApproveNewServiceForm

const useStyles = makeStyles({
    root: {
        width: '100%',
        padding: '20px',
        marginLeft: '60px'
    }
})
